// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1SwOV","title":"InfoRow_title__-6gn-"};